/** Validaciones de guardado del editor de blog (Portal). */

export const PUBLISH_WITHOUT_IMAGE_ERROR =
    'No se puede publicar sin imagen principal. Elige una en el selector de medios o guarda como borrador.';

export const BLOG_SAVE_SUCCESS_MESSAGE =
    'Guardado en la BD. La web pública se actualizará en la próxima ejecución de la pipeline Aipeces-Landing-Pro (las URL nuevas dan 404 hasta entonces).';

/**
 * Bloquea publicar (status enabled) sin imagen principal.
 * Borrador y revisión sin imagen siguen permitidos.
 */
export function validatePublishRequiresMainImage(
    status: string,
    mainImageUrl: string | null | undefined,
): string | null {
    if (status === 'enabled' && !(mainImageUrl || '').trim()) {
        return PUBLISH_WITHOUT_IMAGE_ERROR;
    }
    return null;
}
